import type { ClientComment } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineCommentEventsApi } from '@/features/api/hooks/grapevine-comment-events/useGrapevineCommentEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useUnlikeComment = () => {
  const queryClient = useQueryClient();
  const api = useGrapevineCommentEventsApi();

  return useApiMutation({
    mutationFn: (commentId: string) =>
      api.onUnlikeCommentRequest({
        clientUnlikeCommentRequest: { commentId }
      }),
    onSuccess: (data, commentId) => {
      const postId = data.comment.postId;
      if (!postId) return;
      queryClient.setQueriesData(
        { queryKey: [API_CACHE_KEYS.COMMENTS, postId] },
        (comments: ClientComment[]) => {
          if (!comments) return comments;
          return comments.map((comment) =>
            commentId === comment.id ? data.comment : comment
          );
        }
      );
    }
  });
};
